import { Tabs } from "@mantine/core";
import React from "react";
import Upc from "./Tabs/Upc";
import InventoryHistory from "./Tabs/InventoryHistory";
import { useStyle } from "../InventoryOrders.styles";

const Inventory = () => {
  const { classes } = useStyle();
  return (
    <div>
      <div>
        <h1 className={classes.headerText}>Inventory</h1>
      </div>

      <Tabs defaultValue="upc">
        <Tabs.List>
          <Tabs.Tab value="upc">UPC</Tabs.Tab>
          <Tabs.Tab value="inventoryHistory">Inventory History</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="upc" pt="xs">
          <Upc />
        </Tabs.Panel>

        <Tabs.Panel value="inventoryHistory" pt="xs">
          <InventoryHistory />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default Inventory;
